import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Status.scss';
const StatusThumbReactView = (props)=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(MinimalDumbo, props));
StatusThumbReactView.displayName = 'StatusThumbReactView';
export default StatusThumbReactView;

//# sourceMappingURL=Status.js.map